import { useEffect, useState } from "react";

import {
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  Divider,
  Switch,
  Icon,
} from "@mui/material";

import SoftBox from "softcomponents/SoftBox";
import SoftTypography from "softcomponents/SoftTypography";
import SoftButton from "softcomponents/SoftButton";

import setConsent from "app/utils/consent/setConsent";
import getConsent from "app/utils/consent/getConsent";
import { BASE_URL } from "settings";

const CookieConsent = ({ setOpen }) => {
  const [performance, setPerformace] = useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    const consent = getConsent();
    setPerformace(consent.performance);
  }, []);

  const submitConsent = () => {
    setConsent(performance);
    handleClose();
  };

  const acceptAll = () => {
    setConsent(true);
    handleClose();
  };

  const rejectAll = () => {
    setConsent(false);
    handleClose();
  };

  return (
    <Dialog
      open={true}
      fullWidth={true}
      maxWidth="md"
      onClose={handleClose}
      sx={{ backdropFilter: "blur(5px)" }}
    >
      <SoftBox p={2}>
        <DialogTitle>
          <SoftBox
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <SoftBox>
              <SoftTypography variant="h5" fontWeight="bold" lineHeight={1}>
                {"ตั้งค่าความเป็นส่วนตัว"}
              </SoftTypography>
            </SoftBox>
            <SoftBox onClick={handleClose} sx={{ cursor: "pointer" }}>
              <Icon>close</Icon>
            </SoftBox>
          </SoftBox>
        </DialogTitle>
        <DialogContentText px={2}>
          <SoftTypography variant="caption" lineHeight={0}>
            {
              "เมื่อคุณเข้าสู่เว็บไซต์ใด ๆ ของเรา เราอาจเก็บข้อมูลจากเบราว์เซอร์ในรูปแบบคุกกี้ (ส่วนมาก แต่ไม่จำเป็นต้องเป็นคุกกี้เท่านั้น) ทั้งนี้ ข้อมูลดังกล่าวอาจเป็นข้อมูลที่เกี่ยวข้องกับคุณ ความชอบของคุณ หรืออุปกรณ์ของคุณ เพื่อพัฒนาเว็บไซต์ของเราให้ตรงตามความต้องการของคุณ ข้อมูลดังกล่าวจะไม่ถูกใช้งานเพื่อระบุตัวตนของคุณ แต่จะใช้ข้อมูลดังกล่าวจะช่วยให้คุณได้ใช้งานอย่างตรงกับความต้องการ และเนื่องจากเราให้คุณค่ากับความเป็นส่วนตัวของคุณ คุณจึงสามารถเลือกที่จะไม่อนุญาตให้คุกกี้บางชนิดทำงานได้ คุณสามารถกดเลือกในแต่ละประเภทคุกกี้ และตัดสินใจอนุญาตเป็นบางรายการได้ตามความต้องการของคุณ อย่างไรก็ตาม การไม่อนุญาตให้คุกกี้บางชนิดทำงาน อาจส่งผลต่อความสะดวกสบายในการใช้งานเว็บไซต์และบริการต่าง ๆ ที่เราสามารถเสนอให้คุณได้"
            }
          </SoftTypography>
          <SoftTypography variant="caption" lineHeight={0}>
            {" "}
            {"เรียนรู้เพิ่มเติมเกี่ยวกับ"}{" "}
          </SoftTypography>
          <SoftTypography
            variant="caption"
            color="dark"
            component="a"
            href={`${BASE_URL}/privacy/cookies`}
            target="_blank"
            rel="noreferrer"
            sx={{
              "&:hover": {
                color: ({ palette: { info } }) => info.main,
              },
            }}
          >
            {"นโยบายคุกกี้."}
          </SoftTypography>
        </DialogContentText>
        <DialogContent>
          <SoftBox my={2}>
            <Divider />
          </SoftBox>

          <SoftBox display="flex" justifyContent="space-between">
            <SoftBox>
              <SoftTypography variant="body2">
                {"จำเป็นอย่างยิ่ง"}
              </SoftTypography>
            </SoftBox>
            <SoftBox>
              <Switch checked={true} />
            </SoftBox>
          </SoftBox>
          <SoftBox my={2}>
            <Divider />
          </SoftBox>
          <SoftBox display="flex" justifyContent="space-between">
            <SoftBox>
              <SoftTypography variant="body2">{"ประสิทธิภาพ"}</SoftTypography>
            </SoftBox>
            <SoftBox>
              <Switch
                checked={performance}
                onChange={() => {
                  setPerformace(!performance);
                }}
              />
            </SoftBox>
          </SoftBox>
          <SoftBox my={2}>
            <Divider />
          </SoftBox>
        </DialogContent>
        <DialogContent>
          <Grid container spacing={2} justifyContent="space-between">
            <Grid
              container
              item
              xs="auto"
              direction={{ xs: "column", md: "row" }}
              spacing={2}
            >
              <Grid item>
                <SoftButton
                  variant="outlined"
                  color="secondary"
                  size="small"
                  onClick={acceptAll}
                >
                  {"ยอมรับทั้งหมด"}
                </SoftButton>
              </Grid>
              <Grid item>
                <SoftButton
                  variant="outlined"
                  color="secondary"
                  size="small"
                  onClick={rejectAll}
                >
                  {"ปฎิเสธทางเลือกทั้งหมด"}
                </SoftButton>
              </Grid>
            </Grid>
            <Grid item xs="auto">
              <SoftButton
                variant="gradient"
                color="success"
                size="small"
                onClick={submitConsent}
              >
                {"ยืนยัน"}
              </SoftButton>
            </Grid>
          </Grid>
        </DialogContent>
      </SoftBox>
    </Dialog>
  );
};

export default CookieConsent;
